import { lazy } from 'react'

export const CulturePage = lazy(() => import('./Culture'))
export const CultureAddPage = lazy(() => import('./CultureAdd'))
export const CultureEditPage = lazy(() => import('./CultureEdit'))